import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { fetchData } from "./../fetchData";

export const useGetTeacherCoursesList = () => {
    return useQuery({
        queryKey: ["teachers/my-courses"],
        queryFn: () => fetchData(`teachers/my-courses`),

    });
};

export const useGetTeacherSkillToSchoolCourses = () => {
    return useQuery({
        queryKey: ["teachers/explore/skill-to-school"],
        queryFn: () => fetchData(`teachers/explore/skill-to-school`),

    });
};

export const useGetTeacherSkillFourTeachersCourses = () => {
    return useQuery({
        queryKey: ["teachers/explore/skill-for-teachers"],
        queryFn: () => fetchData(`teachers/explore/skill-for-teachers`),

    });
};

// export const useGetLMSDetail = (id) => {
//   return useQuery({
//     queryKey: ["lms/content"],
//     queryFn: () => fetchData(`lms/${id}/content`),

//   });
// };


export const useGetLMSDetail = (id) => {
    return useQuery({
        queryKey: ["lms/content"],
        queryFn: () => fetchData(`lms/course-content/${id}`),

    });
};

export const useGetSvLMSBasicDetail = (id) => {
    return useQuery({
        queryKey: ["lms/details",id],
        queryFn: () => fetchData(`lms/details/${id}`),
        enabled: !!id,

    });
};

export const useGetSvLMSMilestone = (id) => {
    return useInfiniteQuery({
        queryKey: ["lms/milestones", id],

        queryFn: ({ pageParam = 1 }) =>
            fetchData(`lms/milestones/${id}?page=${pageParam}&limit=10`),

        getNextPageParam: (lastPage) => {
            return lastPage.page < lastPage.totalPages
                ? lastPage.page + 1
                : undefined;
        },
    });
};

export const useGetSvLMSSprint = (id) => {
    return useInfiniteQuery({
        queryKey: ["lms/sprints", id],

        queryFn: ({ pageParam = 1 }) =>
            fetchData(`lms/sprints/${id}?page=${pageParam}&limit=10`),

        getNextPageParam: (lastPage) => {
            return lastPage.page < lastPage.totalPages
                ? lastPage.page + 1
                : undefined;
        },
    });
};



export const useGetSvLMSSpritDetail = (id) => {
    return useQuery({
        queryKey: ["lms/topics",id],
        queryFn: () => fetchData(`lms/topics/${id}`),
           enabled: !!id,

    });
};






